import { ExportAPI } from '../../../api/datamanager/ExportAPI';

export class ExportCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = ExportAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    export(model, provider, successCallback, errorCallback) {
        const apiResult = ExportAPI.export(model, provider);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Exportação realizada com sucesso.");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/ExportCommand.js